import { render, staticRenderFns } from "./InstructorHeader.vue?vue&type=template&id=9de31f24"
import script from "./InstructorHeader.vue?vue&type=script&lang=js"
export * from "./InstructorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports